document.addEventListener('DOMContentLoaded', function() {
    // Translations object
    const translations = {
        pl: {
            childWeight: 'Waga dziecka',
            yourWeight: 'Twoja waga',
            ageAdvice36: '<p><strong>Uwaga:</strong> Dla dzieci w wieku 3-6 lat rekomendowana waga kołdry to 7% masy ciała. Kołdra obciążeniowa powinna być używana tylko pod stałym nadzorem osoby dorosłej.</p>',
            ageAdvice710: '<p><strong>Uwaga:</strong> Dla dzieci w wieku 7-10 lat rekomendowana waga kołdry to 7-10% masy ciała.</p>',
            ageAdvice1113: '<p><strong>Uwaga:</strong> Dla dzieci w wieku 11-13 lat rekomendowana waga kołdry to około 10% masy ciała.</p>',
            ageAdvice14plus: '<p><strong>Uwaga:</strong> Dla młodzieży od 14 lat zalecenia są podobne jak dla dorosłych - 10% masy ciała.</p>'
        },
        en: {
            childWeight: "Child's weight",
            yourWeight: 'Your weight',
            ageAdvice36: '<p><strong>Perfect choice for little dreamers!</strong> For children aged 3-6 years, we recommend a gentle 7% of body weight. Our weighted blankets provide the ultimate comfort and security, but remember - always supervise your little one for the safest sleep experience.</p>',
            ageAdvice710: '<p><strong>Growing kids deserve better sleep!</strong> For children aged 7-10 years, the sweet spot is 7-10% of body weight. Our expertly designed blankets help reduce bedtime stress and promote deeper, more restful sleep naturally.</p>',
            ageAdvice1113: '<p><strong>Supporting your pre-teen\'s sleep journey!</strong> For children aged 11-13 years, we recommend approximately 10% of body weight. Experience the calming benefits that help ease anxiety and create the perfect sleep environment for growing minds.</p>',
            ageAdvice14plus: '<p><strong>Teen-approved comfort!</strong> For youth aged 14 and older, our recommendations align with adult guidelines - 10% of body weight. Discover the science-backed solution that transforms restless nights into rejuvenating sleep.</p>'
        }
    };

    // Detect current language
    function getCurrentLanguage() {
        // Try to get from Shopify locale first
        if (typeof Shopify !== 'undefined' && Shopify.locale) {
            return Shopify.locale;
        }
        
        // Fallback to URL detection
        const path = window.location.pathname;
        if (path.startsWith('/en/') || path.includes('/en/')) {
            return 'en';
        }
        
        // Default to Polish
        return 'pl';
    }

    const currentLang = getCurrentLanguage();
    const t = translations[currentLang] || translations.pl;

    // Get form elements
    const calculatorForm = document.getElementById('calculatorForm');
    const userTypeRadios = document.getElementsByName('userType');
    const yourWeightInput = document.getElementById('yourWeight');
    const yourWeightUnit = document.getElementById('yourWeightUnit');
    const partnerWeightGroup = document.getElementById('partnerWeightGroup');
    const partnerWeightInput = document.getElementById('partnerWeight');
    const partnerWeightUnit = document.getElementById('partnerWeightUnit');
    const blanketWeightDisplay = document.getElementById('blanketWeight');
    const reloadButton = document.getElementById('reloadCalculator');
    const ageSelector = document.getElementById('ageSelector');
    const childAge = document.getElementById('childAge');
    const ageAdvice = document.getElementById('ageAdvice');
    const weightLabel = document.getElementById('weightLabel');

    // Weight conversion factors (to kg)
    const conversions = {
        kg: 1,
        g: 0.001,
        lb: 0.45359237,
        oz: 0.0283495
    };

    // Function to toggle input fields based on user type
    function toggleInputFields() {
        const selectedUserType = document.querySelector('input[name="userType"]:checked').value;

        // Handle partner weight display
        partnerWeightGroup.style.display = selectedUserType === 'couple' ? 'flex' : 'none';

        // Handle child age selector display
        ageSelector.style.display = selectedUserType === 'child' ? 'block' : 'none';

        // Update weight input label with translations
        if (selectedUserType === 'child') {
            weightLabel.textContent = t.childWeight;
            updateChildAdvice();
        } else {
            weightLabel.textContent = t.yourWeight;
            ageAdvice.style.display = 'none';
        }

        // Reset partner weight when switching to single or child
        if (selectedUserType !== 'couple') {
            partnerWeightInput.value = '';
        }

        calculateBlanketWeight();
    }

    // Function to update child advice based on selected age with translations
    function updateChildAdvice() {
        const selectedAge = childAge.value;
        ageAdvice.style.display = 'block';

        switch (selectedAge) {
            case '3-6':
                ageAdvice.innerHTML = t.ageAdvice36;
                break;
            case '7-10':
                ageAdvice.innerHTML = t.ageAdvice710;
                break;
            case '11-13':
                ageAdvice.innerHTML = t.ageAdvice1113;
                break;
            case '14+':
                ageAdvice.innerHTML = t.ageAdvice14plus;
                break;
        }
    }

    // Function to convert weight to kg
    function convertToKg(value, unit) {
        if (!value || isNaN(value)) return 0;
        return parseFloat(value) * conversions[unit];
    }

    // Function to calculate blanket weight (unchanged)
    function calculateBlanketWeight() {
        const yourWeightKg = convertToKg(yourWeightInput.value, yourWeightUnit.value);
        const selectedUserType = document.querySelector('input[name="userType"]:checked').value;

        let totalWeightKg = yourWeightKg;
        let percentage = 0.1; // Default 10%

        // For couple, add partner weight
        if (selectedUserType === 'couple') {
            const partnerWeightKg = convertToKg(partnerWeightInput.value, partnerWeightUnit.value);
            totalWeightKg += partnerWeightKg;
        }
        // For child, adjust percentage based on age
        else if (selectedUserType === 'child') {
            const selectedAge = childAge.value;
            switch (selectedAge) {
                case '3-6':
                    percentage = 0.07; // 7%
                    break;
                case '7-10':
                    percentage = 0.08; // 8%
                    break;
                case '11-13':
                    percentage = 0.1; // 10%
                    break;
                case '14+':
                    percentage = 0.1; // 10%
                    break;
            }
        }

        // Calculate blanket weight
        let blanketWeightKg;

        if (totalWeightKg <= 180) {
            // Calculate using the appropriate percentage
            blanketWeightKg = totalWeightKg * percentage;
        } else {
            // Cap at 18kg for weights over 180kg
            blanketWeightKg = 18;
        }

        // Round to nearest 0.5 kg
        blanketWeightKg = Math.round(blanketWeightKg * 2) / 2;

        // Cap the maximum blanket weight at 18kg
        if (blanketWeightKg > 18) {
            blanketWeightKg = 18;
        }

        // Ensure minimum weight for children
        if (selectedUserType === 'child' && blanketWeightKg < 1) {
            blanketWeightKg = 1;
        }

        // Display the result
        blanketWeightDisplay.textContent = blanketWeightKg + ' kg';
    }

    // Add event listeners
    userTypeRadios.forEach(radio => {
        radio.addEventListener('change', toggleInputFields);
    });

    childAge.addEventListener('change', function() {
        updateChildAdvice();
        calculateBlanketWeight();
    });

    yourWeightInput.addEventListener('input', calculateBlanketWeight);
    partnerWeightInput.addEventListener('input', calculateBlanketWeight);
    yourWeightUnit.addEventListener('change', calculateBlanketWeight);
    partnerWeightUnit.addEventListener('change', calculateBlanketWeight);

    reloadButton.addEventListener('click', function() {
        calculatorForm.reset();
        userTypeRadios[0].checked = true;
        toggleInputFields();
        calculateBlanketWeight();
    });

    // Initialize
    toggleInputFields();
});